import * as constants from './constants';

export const getTags = (payload) => ({ type: constants.GET_TAGS, payload });
export const setTags = (payload) => ({ type: constants.SET_TAGS, payload });
export const setTagsLoading = () => ({ type: constants.SET_TAGS_LOADING });
export const resetTags = () => ({ type: constants.RESET_TAGS });
export const getTagsSuccess = (payload) => ({
  type: constants.GET_TAGS_SUCCESS,
  payload,
});

export const getTagsError = (payload) => ({
  type: constants.GET_TAGS_ERROR,
  payload,
});
